// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3sd58","right":"Footer_right__hvC97","buttons":"Footer_buttons__2W5G1"};